import React from 'react';
import { connect } from "react-redux";
import { addWorkSession } from "../../actions/CustomerActions";
import ProjectCellDetailModal from "./ProjectCellDetailModal";

const WAIT_INTERVAL = 5000;

class ProjectCell extends React.Component {

    componentWillReceiveProps(nextProps) {
        this.setState({ workSessions: nextProps.workSessions });

        if (nextProps.workSessions && nextProps.workSessions.numberOfHours !== 0) {
            this.setState({ isValid: true });
        } else {
            this.setState({ isValid: false });
        }
    }

    componentWillMount() {
        this.setState({
            workSessions: this.props.workSessions,
            state: "",
            isValid: (this.props.workSessions && this.props.workSessions.numberOfHours !== 0),
            isSaving: false
        });

        this.timer = null;
        this.submitLock = false;

        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = (now.getMonth() + 1).toString().padStart(2, "0");
        const dd = now.getDate().toString().padStart(2, "0");
        const todayString = yyyy + "-" + mm + "-" + dd;

        this.setState({
            today: this.props.date === todayString
        });
    }

    normalizeStatus(rawStatus) {
        if (!rawStatus) return null;

        var s = String(rawStatus).trim().toUpperCase();

        if (s === "GEACCEPTEERD") s = "ACCEPTED";
        if (s === "GEFACTUREERD") s = "INVOICED";
        if (s === "AFWACHTEND") s = "PENDING";
        if (s === "AFGEWEZEN") s = "DISCARDED";

        return s;
    }

    getWorkSessionStatus() {
        if (this.state.workSessions == null) return null;

        var raw = this.state.workSessions.evaluation || this.state.workSessions.state;
        return this.normalizeStatus(raw);
    }

    render() {
        const readOnly = (this.props.readOnly === true);

        var classes = [];
        var attr = {};
        var immutable = false;

        if (this.props.freeDay) {
            classes.push("free-day");
        }

        classes.push(this.state.state);

        var loading = (this.props.isLoading === true);
        var saving = !!(this.state && this.state.isSaving);
        var savingGlobal = (this.props.isSavingGlobal === true);
        var blocked = loading || savingGlobal || saving;

        if (blocked) {
            immutable = true;
            attr = { disabled: true, readOnly: true };
        }

        var wsStatus = this.getWorkSessionStatus();

        if (wsStatus) {
            classes.push(wsStatus);
        }

        if (wsStatus === "ACCEPTED" || wsStatus === "INVOICED") {
            classes.push("success-color");
            classes.push("cell-locked");
            immutable = true;
            attr = { disabled: true, readOnly: true };
        }

        if (wsStatus === "DISCARDED") {
            classes.push("error-color");
            // bewust NIET immutable maken
        }

        if (this.props.archived) {
            immutable = true;
            classes.push("cell-locked");
            attr = { disabled: true, readOnly: true };
        }

        if (readOnly) {
            immutable = true;
            classes.push("cell-locked");
            attr = { disabled: true, readOnly: true };
            classes = classes.filter(function (c) {
                return ["success", "success-2", "error", "error-2"].indexOf(c) === -1;
            });
        }

        if (this.state.isValid) {
            classes.push("contains-modal-button");
        }

        if (this.state.today) {
            classes.push("today");
        }

        return (
            <div className="relative cell">
                <input
                    type="text"
                    {...attr}
                    className={classes.join(" ")}
                    value={this.state.workSessions ? this.state.workSessions.numberOfHours : ""}
                    onBlur={blocked ? undefined : this.onBlur.bind(this)}
                    onKeyDown={blocked ? undefined : this.onKeyDown.bind(this)}
                    onChange={blocked ? undefined : this.onChange.bind(this)}
                />

                {this.state.isValid && (
                    <ProjectCellDetailModal
                        onChange={blocked ? undefined : this.onDescriptionChange.bind(this)}
                        value={this.state.workSessions ? this.state.workSessions.description : ""}
                        immutable={immutable}
                        disabled={blocked}
                        onSubmit={blocked ? undefined : this.onDescriptionSubmit.bind(this)}
                    />
                )}
            </div>
        );
    }

    onBlur(event) {
        if (this.submitLock) return;

        this.handleSubmit(event.currentTarget.value);
    }

    onKeyDown(event) {
        if (event.keyCode === 13 || event.keyCode === 9) {
            event.preventDefault();

            this.submitLock = true;

            this.handleSubmit(event.currentTarget.value);

            setTimeout(() => {
                this.submitLock = false;
            }, 150);
        }
    }

    onChange(event) {
        if (this.props.readOnly === true) return;

        clearTimeout(this.timer);

        var value = event.currentTarget.value;
        var workSessions = this.state.workSessions || {
            numberOfHours: 0,
            description: "",
            date: this.props.date
        };

        workSessions.numberOfHours = value;
        this.setState({ workSessions: workSessions });

        if (this.submitLock) return;

        this.timer = setTimeout(() => {
            this.handleSubmit(this.state.workSessions.numberOfHours);
        }, WAIT_INTERVAL);
    }

    onDescriptionChange(input) {
        if (this.props.readOnly === true) return;

        var ws = Object.assign({}, this.state.workSessions);
        ws.description = input;
        this.setState({ workSessions: ws });
    }

    onDescriptionSubmit() {
        if (this.props.readOnly === true) return;

        var wsStatus = this.getWorkSessionStatus();

        if (wsStatus !== "ACCEPTED" && wsStatus !== "INVOICED") {
            this.handleSuccess();
        }
    }

    handleSubmit(input) {
        if (this.props.readOnly === true) return;

        clearTimeout(this.timer);

        if (input != null) {
            var workSessions = this.state.workSessions || {};
            workSessions.numberOfHours = this.parseInput(input);
            this.setState({ workSessions: workSessions });
            this.handleSuccess();
        }
    }

    handleSuccess() {
        if (this.props.readOnly === true) return;

        var ws = this.state.workSessions || {};
        var numberOfHours = ws.numberOfHours || 0;
        var description = ws.description || "";

        this.setState({
            state: this.state.state === "success" ? "success-2" : "success"
        });

        this.setState({
            workSessions: Object.assign({}, ws, { evaluation: null })
        });

        this.setState({ isValid: numberOfHours !== 0 });
        this.setState({ isSaving: true });

        var data = {
            time: numberOfHours,
            date: this.props.date,
            project: this.props.project,
            customer: this.props.customer,
            description: description
        };

        this.props.addWorkSession(data)
            .then(() => {
                this.setState({ isSaving: false });

                if (this.props.onWorkSessionSaved) {
                    this.props.onWorkSessionSaved();
                }
            })
            .catch(() => {
                this.setState({ isSaving: false });
                alert("Er ging iets mis bij het opslaan in Mendix.");
                this.handleError();
            });

        if (this.props.updateHolidaySaldo) {
            this.props.updateHolidaySaldo();
        }
    }

    handleError() {
        this.setState({
            state: this.state.state === "error" ? "error-2" : "error"
        });
    }

    parseInput(value) {
        if (value == null) return 0;

        var raw = String(value).trim();
        if (raw === "") return 0;

        var hours = 0;

        if (raw.indexOf(":") > -1) {
            hours = ProjectCell.parseColonValue(raw);
            return ProjectCell.roundUpToQuarter(hours);
        }

        if (raw.indexOf(",") > -1 || raw.indexOf(".") > -1) {
            hours = ProjectCell.parseDotOrCommaValue(raw);
            return ProjectCell.roundUpToQuarter(hours);
        }

        hours = ProjectCell.parseWholeNumberValue(raw);
        return ProjectCell.roundUpToQuarter(hours);
    }

    static parseWholeNumberValue(value) {
        var n = parseInt(value, 10);
        if (isNaN(n)) return 0;

        if (n >= 30) return n / 60;

        return n;
    }

    static roundUpToQuarter(hours) {
        var n = parseFloat(hours);
        if (!isFinite(n) || n <= 0) return 0;

        var rounded = Math.ceil(n * 4) / 4;
        return parseFloat(rounded.toFixed(2));
    }

    static parseDotOrCommaValue(value) {
        value = value.replace(",", ".");
        return parseFloat(value) || 0;
    }

    static parseColonValue(value) {
        if ([":", ":0", ":00", "0:00", "00:00", "00:0", "00:", "0:0", "0:"].indexOf(value) > -1) {
            return 0;
        }

        var parts = value.split(":");
        var h = parseInt(parts[0], 10) || 0;
        var m = parseInt(parts[1], 10) || 0;

        return h + (m / 60);
    }
}

function mapStateToProps(state) {
    return {
        isLoading: state.customers.isLoadingCustomerProjects,
        isSavingGlobal: state.customers.isSavingWorkSession
    };
}

export default connect(mapStateToProps, { addWorkSession })(ProjectCell);